import { OPTION_LIST } from '../../../components/StatelessComponent/SingleFilter/UTurnFilter/UTurnFilterConstant';
import type { U_TURN_TYPE } from '../../../components/StatelessComponent/SingleFilter/UTurnFilter/UTurnFilterType';
import { FilterKindEnum } from '../../../domains/global-filters/model/FilterChain';
import type { LabelProps } from '../LabelFormatterType';
import { getLabels as radioLabelFormatterGetLabels } from './GenericLabelFormatter/RadioLabelFormatter';

export function getLabels(currentValue?: U_TURN_TYPE): LabelProps {
  return radioLabelFormatterGetLabels(currentValue, FilterKindEnum.UTurnKind, OPTION_LIST);
}
